import { Badge } from 'react-bootstrap';
import { statusWord } from '@/utils/deployStatus';
import './deployments.css';

interface StatusPillProps {
  status?: string;
  /** Above 1 when the pipeline ran the deploy a second time by itself. */
  attemptNumber?: number;
}

/** A run's status as one word. The old "(1/2)" attempt counter is gone: it said nothing on 98 of 100 runs. */
export function StatusPill({ status, attemptNumber }: StatusPillProps) {
  const word = statusWord(status);
  return (
    <span className="deploy-status">
      <Badge bg={word.tone}>
        {word.live && <span className="deploy-status__dot" aria-hidden="true" />}
        {word.label}
      </Badge>
      {/* "Retrying" already says it: the tag is for a run that is past its second start. */}
      {(attemptNumber ?? 1) > 1 && (status || '').toLowerCase() !== 'retrying' && (
        <span
          className="deploy-status__tag"
          title="The first attempt failed, so the pipeline ran the deploy a second time."
        >
          Retried
        </span>
      )}
    </span>
  );
}

export default StatusPill;
